import { render, staticRenderFns } from "./AnonContactInfo.vue?vue&type=template&id=2a644892&"
import script from "./AnonContactInfo.vue?vue&type=script&lang=js&"
export * from "./AnonContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports